import { render, staticRenderFns } from "./AXgoods.vue?vue&type=template&id=06c4b06e&scoped=true&"
import script from "./AXgoods.vue?vue&type=script&lang=js&"
export * from "./AXgoods.vue?vue&type=script&lang=js&"
import style0 from "./AXgoods.vue?vue&type=style&index=0&id=06c4b06e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c4b06e",
  null
  
)

export default component.exports